export const THANK_YOU_BUILDER_CHOICE_TYPES = {
  CLASSIC: "classic",
  ADVANCED: "advanced",
};

export const THANK_YOU_BUILDER_CREATE_FROM_SCRATCH_VALUE =
  "create_from_scratch";

export const THANK_YOU_BUILDER_CHOICE_MODAL_TEXTS = {
  TITLE: "Choose Thank You Page Builder",
  PAGE_SELECT_LABEL: "Thank you page",
  PAGE_SELECT_PLACEHOLDER: "Select a thank you page",
  PAGE_SELECT_DESCRIPTION:
    "Choose an existing page or create a new one from scratch.",
  SELECT_PAGE_HEADING: "Select a thank you page",
  BUILDER_HEADING: "How do you want to design your page?",
  CREATE_FROM_SCRATCH_LABEL: "Create from scratch",
  CONTINUE: "Continue",
  CONTINUE_EDITING: "Continue Editing",
};

export const THANK_YOU_BUILDER_QUERY_KEYS = {
  LISTING_UUID: "listing_uuid",
  PAYMENT_LINK_UUID: "payment_link_uuid",
  PAGE_TYPE: "page_type",
  THANKYOU_PAGE_TYPE: "thankyou_page_type",
};

// Re-exported from ThankYouPages.constants (single source of truth).
// Kept here for back-compat with existing ChoiceModal imports.
export {
  THANK_YOU_PAGE_TYPE_VALUES,
  THANK_YOU_PAGE_TYPE_STRINGS,
} from "features/ThankYouPages/constants/ThankYouPages.constants";
